import  axiosInstance  from './request';
import jsonp from './jsonp';

function reqJONP(url, params, opts) {
    return jsonp(url, params, opts);
}

const http = {
    get(url, params, opts) {
        // reqJONP("./fuwu/authStatus").then((res) => {
        //     if(res.hasLogin) {
        //         return axiosInstance.get(url, {
        //             params,
        //             ...opts,
        //         });
        //     }
            
        // })
        return axiosInstance.get(url, {
            params,
            ...opts,
        });
    },
    post(url, params, opts) {
        return axiosInstance.post(url, params, {
            ...opts,
        });
    },
    put(url, params, opts) {
        return axiosInstance.put(url, params, {
            ...opts,
        });
    },
    delete(url, params, opts) {
        return axiosInstance.delete(url, {
            params,
            ...opts,
        });
    },
    jsonp(url, params, opts) {
        return reqJONP(url, params, opts);
    }
};

export function httpService(path, obj , ...props ) {
    return (params) => {
        const url = path;
        return http[obj.method](
            url, params, ...props
        );
    };
}
